export interface StorageAdapter {
  getItem(): string | null | undefined;
  setItem(value: string): void;
  removeItem(): void;
}

type CachedCoupon = {
  code: string;
  cachedAt: number;
};

export const SSP_COUPON_TTL_MS = 7 * 24 * 60 * 60 * 1000; // 7 days

type SSPCouponCache = {
  cacheSSPCoupon: (code: string) => void;
  getCachedSSPCoupon: () => string | null;
  clearSSPCoupon: () => void;
};

export function createSSPCouponCache(adapter: StorageAdapter): SSPCouponCache {
  function cacheSSPCoupon(code: string): void {
    const entry: CachedCoupon = { code, cachedAt: Date.now() };
    adapter.setItem(JSON.stringify(entry));
  }

  function getCachedSSPCoupon(): string | null {
    const stored = adapter.getItem();
    if (!stored) return null;

    try {
      const entry = JSON.parse(stored) as CachedCoupon;
      if (Date.now() - entry.cachedAt > SSP_COUPON_TTL_MS) {
        adapter.removeItem();
        return null;
      }
      return entry.code;
    } catch {
      adapter.removeItem();
      return null;
    }
  }

  function clearSSPCoupon(): void {
    adapter.removeItem();
  }

  return { cacheSSPCoupon, getCachedSSPCoupon, clearSSPCoupon };
}
